"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRouterDom = require("react-router-dom");

var _qs = _interopRequireDefault(require("qs"));

var _urijs = _interopRequireDefault(require("urijs"));

var _Main = _interopRequireDefault(require("./tabs/heatmap/Main.js"));

var _Main2 = _interopRequireDefault(require("./tabs/experiment-design/Main.js"));

var _Main3 = _interopRequireDefault(require("./tabs/resources/Main.js"));

var _StaticTable = _interopRequireDefault(require("./tabs/StaticTable.js"));

var _Main4 = _interopRequireDefault(require("./tabs/qc-report/Main.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var TabPropType = _propTypes["default"].shape({
  type: _propTypes["default"].string.isRequired,
  name: _propTypes["default"].string.isRequired,
  props: _propTypes["default"].object.isRequired
}); //coupled to ExperimentController.java


var componentsPerTab = {
  'multipart': "",
  'heatmap': _Main["default"],
  'experiment-design': _Main2["default"],
  'resources': _Main3["default"],
  'static-table': _StaticTable["default"],
  'qc-report': _Main4["default"]
};

var createPageSection = function createPageSection(_ref) {
  var type = _ref.type,
      props = _ref.props;
  var Tab = componentsPerTab[type];
  return /*#__PURE__*/_react["default"].createElement(Tab, props);
};

var createPage = function createPage(_ref2) {
  var type = _ref2.type,
      commonProps = _ref2.commonProps,
      tabProps = _ref2.tabProps;
  return type === "multipart" ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "row expanded column margin-top-large"
  }, tabProps.sections.map(function (_ref3) {
    var type = _ref3.type,
        name = _ref3.name,
        props = _ref3.props;
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: name,
      className: "row column expanded"
    }, /*#__PURE__*/_react["default"].createElement("h4", null, name), createPageSection({
      type: type,
      props: Object.assign({}, commonProps, props)
    }));
  })) : createPageSection({
    type: type,
    props: Object.assign({}, commonProps, tabProps)
  });
};

var queryFromRouteDetails = function queryFromRouteDetails(_ref4) {
  var search = _ref4.location.search;
  return _qs["default"].parse(search.replace(/^\?/, ""));
};

var makeTab = function makeTab(_ref5) {
  var type = _ref5.type,
      commonProps = _ref5.commonProps,
      tabProps = _ref5.tabProps;
  return function (routeDetails) {
    return createPage({
      type: type,
      commonProps: Object.assign({}, commonProps, {
        query: queryFromRouteDetails(routeDetails)
      }),
      tabProps: tabProps
    });
  };
};

var makeTopRibbon = function makeTopRibbon(tabNames) {
  return (0, _reactRouterDom.withRouter)(function (_ref6) {
    var location = _ref6.location;
    return /*#__PURE__*/_react["default"].createElement("ul", {
      className: "tabs"
    }, tabNames.map(function (tabName) {
      return /*#__PURE__*/_react["default"].createElement("li", {
        title: tabName,
        key: tabName,
        className: "tabs-title"
      }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.NavLink, {
        to: {
          pathname: "/".concat(tabName),
          search: location.search,
          hash: location.hash
        },
        activeStyle: {
          color: "#0a0a0a",
          background: "#e6e6e6"
        }
      }, tabName));
    }));
  });
};

var RedirectToTabWithLocation = /*#__PURE__*/function (_React$Component) {
  _inherits(RedirectToTabWithLocation, _React$Component);

  var _super = _createSuper(RedirectToTabWithLocation);

  function RedirectToTabWithLocation() {
    _classCallCheck(this, RedirectToTabWithLocation);

    return _super.apply(this, arguments);
  }

  _createClass(RedirectToTabWithLocation, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Redirect, {
        to: {
          pathname: "/".concat(this.props.tabName),
          search: this.props.location.search,
          hash: this.props.location.hash
        }
      });
    }
  }]);

  return RedirectToTabWithLocation;
}(_react["default"].Component);

var RedirectToTab = (0, _reactRouterDom.withRouter)(RedirectToTabWithLocation);

var ExperimentContainerRouter = function ExperimentContainerRouter(_ref7) {
  var atlasUrl = _ref7.atlasUrl,
      pathToResources = _ref7.pathToResources,
      experimentAccession = _ref7.experimentAccession,
      experimentType = _ref7.experimentType,
      accessKey = _ref7.accessKey,
      species = _ref7.species,
      disclaimer = _ref7.disclaimer,
      tabs = _ref7.tabs;
  var commonProps = Object.assign({
    atlasUrl: atlasUrl,
    pathToResources: pathToResources,
    experimentAccession: experimentAccession,
    experimentType: experimentType,
    accessKey: accessKey,
    species: species,
    disclaimer: disclaimer
  }, {
    isDifferential: experimentType.toLowerCase().includes("differential"),
    isProteomics: experimentType.toLowerCase().includes("proteomics"),
    isRnaSeq: experimentType.toLowerCase().replace("_", "").includes("rnaseq")
  });
  return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.BrowserRouter, {
    basename: (0, _urijs["default"])("experiments/".concat(experimentAccession), atlasUrl).toString()
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
    path: "/",
    component: makeTopRibbon(tabs.map(function (tab) {
      return tab.name;
    }))
  }), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Switch, null, tabs.map(function (tab) {
    return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
      key: tab.name,
      path: "/".concat(tab.name),
      component: makeTab({
        type: tab.type,
        commonProps: commonProps,
        tabProps: tab.props
      })
    });
  }), /*#__PURE__*/_react["default"].createElement(RedirectToTab, {
    tabName: tabs[0].name
  }))));
};

ExperimentContainerRouter.propTypes = {
  atlasUrl: _propTypes["default"].string.isRequired,
  pathToResources: _propTypes["default"].string.isRequired,
  experimentAccession: _propTypes["default"].string.isRequired,
  experimentType: _propTypes["default"].string.isRequired,
  accessKey: _propTypes["default"].string,
  species: _propTypes["default"].string.isRequired,
  tabs: _propTypes["default"].arrayOf(TabPropType).isRequired,
  disclaimer: _propTypes["default"].string.isRequired
};
var _default = ExperimentContainerRouter;
exports["default"] = _default;